import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { ICreateGroupRequest, ICreateGroupResponse, IGroup } from 'src/services/api/groups';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_GROUPS_PATH } from 'src/services/api/groups/constants';

export const useCreateGroup = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<
    IGroup,
    IStandardErrorResponse,
    ICreateGroupRequest
    >(
        async (payload) => {
            const res = await apiClient(GET_GROUPS_PATH, {
                method: 'post',
                json: payload,
            }).json<ICreateGroupResponse>();

            return res.group;
        }, {
            onSuccess: (group) => {
                addNotification('Group created successfully', 'success');

                queryClient.setQueryData<IGroup[]>(queryKeys.groups, (oldData) => {
                    if (!oldData) {
                        return [group];
                    }

                    return [...oldData, group];
                });

                queryClient.setQueryData<IGroup>([queryKeys.groups, group.id], group);
            },
        });
};